import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { MessageCircle, Instagram } from 'lucide-react';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="home" className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-151">
      {/* Split Backgrounds */}
      <div className="absolute inset-0 flex w-full h-full" data-id="element-152">
        {/* Left: Rainforest */}
        <div className="w-1/2 h-full relative" data-id="element-153">
          <img src="https://cdn.magicpatterns.com/uploads/kfDeyTtRD8RQtGNQp57J74/WhatsApp_Image_2026-06-15_at_15.59.40.jpg" alt="El Yunque rainforest adventure" className="w-full h-full object-cover object-center" data-id="element-154" />
          <div className="absolute inset-0 bg-rainforest-dark/40 mix-blend-multiply" data-id="element-155" />
        </div>
        {/* Right: Ocean */}
        <div className="w-1/2 h-full relative" data-id="element-156">
          <img src="https://cdn.magicpatterns.com/uploads/56AMYLmu8MoESkEUsRU6DE/WhatsApp_Image_2026-06-15_at_15.59.44.jpg" alt="Private boat tour in turquoise water" className="w-full h-full object-cover object-[center_35%]" data-id="element-157" />
          <div className="absolute inset-0 bg-ocean-dark/30 mix-blend-multiply" data-id="element-158" />
        </div>
      </div>

      {/* Cinematic Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-ocean-dark/90 via-ocean-dark/40 to-transparent" data-id="element-159" />
      <div className="absolute inset-0 bg-black/20" data-id="element-160" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center mt-20" data-id="element-161">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-heading font-bold text-white mb-6 drop-shadow-xl leading-tight" data-id="element-162">
          {t.hero.headline}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-2xl text-sand-light mb-10 max-w-3xl mx-auto drop-shadow-md font-light" data-id="element-163">
          {t.hero.subheadline}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-164">
          <motion.a href="https://wa.link/ip0tbk" target="_blank" rel="noreferrer" animate={{
          scale: [1, 1.06, 1],
          boxShadow: ['0 0 16px rgba(26,67,49,0.4)', '0 0 32px rgba(45,90,69,0.85)', '0 0 16px rgba(26,67,49,0.4)']
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.1
        }} className="flex items-center gap-2 bg-rainforest hover:bg-rainforest-light text-white px-8 py-4 rounded-full font-semibold text-lg w-full sm:w-auto justify-center" data-id="element-165">
            <MessageCircle size={20} data-id="element-166" />
            Sweet & Salty
          </motion.a>
          <motion.a href="https://wa.link/qca29f" target="_blank" rel="noreferrer" animate={{
          scale: [1, 1.06, 1],
          boxShadow: ['0 0 16px rgba(0,180,216,0.4)', '0 0 32px rgba(72,202,228,0.85)', '0 0 16px rgba(0,180,216,0.4)']
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.8
        }} whileHover={{
          scale: 1.1
        }} className="flex items-center gap-2 bg-turquoise hover:bg-turquoise-light text-white px-8 py-4 rounded-full font-semibold text-lg w-full sm:w-auto justify-center" data-id="element-167">
            <MessageCircle size={20} data-id="element-168" />
            Blu Ocean Tours
          </motion.a>
        </motion.div>
      </div>
    </section>;
}